import React, { useContext } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import B2BSingle from '../../components/B2BSingle';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';

const B2BSinglePage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      {role === "admin" ? <AdminHeader /> : <LoginHeader />}
      <main>
        <B2BSingle />
      </main>
      <LoginFooter />
    </>
  )
}

export default B2BSinglePage;